
export type QueryMetricsType = typeof QueryMetricsType[keyof typeof QueryMetricsType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QueryMetricsType = {
  PAYMENT_PROCESSED: 'PAYMENT_PROCESSED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  SUBSCRIPTION_CREATED: 'SUBSCRIPTION_CREATED',
  SUBSCRIPTION_CANCELLED: 'SUBSCRIPTION_CANCELLED',
  USER_LOGIN: 'USER_LOGIN',
  API_REQUEST: 'API_REQUEST',
} as const;
